import styled from 'styled-components';

const Controls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 0.5rem;

  * {
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export default Controls;
